import { useQuery } from '@apollo/client';
import {
  GetExternalProjectImportPreviewInput,
  GetExternalProjectImportPreviewResponse,
} from '@provision/entity-types';
import { GET_PORTALIO_PROJECT_IMPORT_PREVIEW } from 'src/graphql/entities/integrations/portalio/portalio.operations';
import { useGlobalStore } from 'src/store';
import { useNotifications } from 'src/utils/hooks';

export const usePortalioProjectImportPreview = (projectIds: number[]) => {
  const { showErrorAlert } = useNotifications();
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();
  const { data, loading } = useQuery<
    {
      getPortalioProjectImportPreview: GetExternalProjectImportPreviewResponse<number>;
    },
    GetExternalProjectImportPreviewInput<number>
  >(GET_PORTALIO_PROJECT_IMPORT_PREVIEW, {
    variables: {
      params: {
        projectIds,
        partnerId: selectedPartnerId!,
      },
    },
    skip: selectedPartnerId === null || projectIds.length === 0,
    onError: (data) => {
      showErrorAlert(data.message);
    },
  });

  return {
    records: data?.getPortalioProjectImportPreview.records,
    errors: data?.getPortalioProjectImportPreview.errors,
    loading,
  };
};
